import { Router } from "next/router";
import React, { useEffect, useState } from "react";
import "../styles/style.scss"
import { SessionProvider } from "next-auth/react";
import { CssBaseline } from "@mui/material";
import { StyledEngineProvider } from "@mui/material/styles";
import "swagger-ui-react/swagger-ui.css";
// import "bootstrap/scss/bootstrap.scss";

// ========= Plugins CSS START =========
import "../components/TensorSearch/style.css";
import "../public/css/plugins/feature.css";
import "../public/css/plugins/fontawesome-all.min.css";
import "../public/css/plugins/animation.css";
import "../node_modules/sal.js/dist/sal.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-tooltip/dist/react-tooltip.css";
import "../components/sign/Login.css"
// ========= Plugins CSS END ========= 
import { Toaster } from "react-hot-toast";
// import "../public/scss/style.scss";
import Loading from "@/components/Loading/Loading";

export default function App({ Component, pageProps }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    require("bootstrap/dist/js/bootstrap.bundle.min.js");

    const handleStart = (url) => url !== Router.asPath && setLoading(true);
    const handleComplete = () => setLoading(false);

    Router.events.on("routeChangeStart", handleStart);
    Router.events.on("routeChangeComplete", handleComplete);
    Router.events.on("routeChangeError", handleComplete);

    return () => {
      Router.events.off("routeChangeStart", handleStart);
      Router.events.off("routeChangeComplete", handleComplete);
      Router.events.off("routeChangeError", handleComplete);
    };
  }, []);

return (
  <>
    {loading ? (
      <Loading />
    ) : (
      <>
        <link
          rel="alternate"
          type="application/rss+xml"
          title="RSS Feed"
          href="https://mobibharat-seller-bucket.s3.amazonaws.com/tensor_search_rss_feed.xml"
        />

        <StyledEngineProvider injectFirst>
          <SessionProvider session={pageProps.session}>
            <CssBaseline />
            <Toaster
              position="top-right"
              toastOptions={{
                // Default options for all toasts
                duration: 3000,
                style: {
                  background: "#ffffff",
                  color: "#333333",
                },
                // Custom success toast styling
                success: {
                  style: {
                    background: "#10B981",
                    color: "white",
                  },
                  iconTheme: {
                    primary: "white",
                    secondary: "#10B981",
                  },
                },
                // Custom error toast styling
                error: {
                  style: {
                    background: "#EF4444",
                    color: "white",
                  },
                  iconTheme: {
                    primary: "white",
                    secondary: "#EF4444",
                  },
                },
              }}
            />
            <Component {...pageProps} />
          </SessionProvider>
        </StyledEngineProvider>
      </>
    )}
  </>
);

}
